var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.75 15.548a.852.852 0 0 1-.275 1.387.85.85 0 0 1-.927-.184L8.5 9.7l-7.048 7.05a.85.85 0 1 1-1.203-1.203L7.3 8.5.248 1.452A.85.85 0 0 1 1.452.249L8.5 7.3l7.048-7.05a.85.85 0 0 1 1.203 1.203L9.7 8.5l7.05 7.048Z"
  })));
};
export default SvgCloseIcon;